import { ReactNode, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "src/redux/store";
import { PATH_DASHBOARD } from "src/routes/paths";
import LoadingScreen from "../components/LoadingScreen";
import useAuth from "../hooks/useAuth";
import Login from "../pages/auth/Login";

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );
  let permissions = useSelector(
    (state: any) => state.credential.userTokenDecode.Permissions
  );
  let organization = useSelector((state: any) => state.organization.org);

  if (!permissions) {
    return <Login />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (
    organization.froce2FASetup &&
    !organization.is2FAEnabled &&
    pathname !== PATH_DASHBOARD.user.account
  ) {
    return <Navigate to={PATH_DASHBOARD.user.account} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
